export enum ECheckoutStep {
  ADDRESS = 'address',
  PERSONAL_INFO = 'personal-info',
  PAYMENT = 'payment',
  OVERVIEW = 'overview',
}
